import { render, staticRenderFns } from "./ChangeProductBlock.vue?vue&type=template&id=3a154023&scoped=true"
import script from "./ChangeProductBlock.vue?vue&type=script&lang=js"
export * from "./ChangeProductBlock.vue?vue&type=script&lang=js"
import style0 from "./ChangeProductBlock.vue?vue&type=style&index=0&id=3a154023&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a154023",
  null
  
)

export default component.exports